import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Campaign as MegaphoneIcon } from '@mui/icons-material';
import { useNotices } from '../../hooks/useNotices';
import NoticeDetailDialog from './NoticeDetailDialog';
import type { Notice } from '../../../types/notice.types';

const NoticeTicker: React.FC = () => {
  const { tickerNotices } = useNotices();
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState<Notice | null>(null);

  if (tickerNotices.length === 0) return null;

  const duration = Math.max(tickerNotices.length * 8, 20);

  const handleClick = (notice: Notice) => {
    setSelectedNotice(notice);
    setDetailOpen(true);
  };

  return (
    <>
      <Box sx={{ maxWidth: { xs: '100%', md: '50%' }, mx: 'auto', px: { xs: 2, md: 0 }, py: 0.5 }}>
        <Box
          sx={{
            bgcolor: '#0f172a',
            borderRadius: { xs: 0, md: 2 },
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            py: 0.8,
            px: { xs: 2, md: 2.5 },
          }}
        >
          <Box
            sx={{
              display: 'flex', alignItems: 'center', gap: 0.5,
              flexShrink: 0, mr: 2, pr: 2, borderRight: '1px solid #334155',
            }}
          >
            <MegaphoneIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
            <Typography sx={{ fontSize: 11, fontWeight: 800, color: '#f59e0b', letterSpacing: 0.5 }}>
              NEWS
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1, overflow: 'hidden',
              maskImage: 'linear-gradient(90deg, transparent 0%, black 5%, black 95%, transparent 100%)',
              WebkitMaskImage: 'linear-gradient(90deg, transparent 0%, black 5%, black 95%, transparent 100%)',
            }}
          >
            <Box
              sx={{
                display: 'flex', width: 'fit-content',
                animation: `tickerMarquee ${duration}s linear infinite`,
                '&:hover': { animationPlayState: 'paused' },
                '@keyframes tickerMarquee': {
                  '0%': { transform: 'translateX(0)' },
                  '100%': { transform: 'translateX(-50%)' },
                },
              }}
            >
              {[0, 1].map((set) => (
                <Box key={set} sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                  {tickerNotices.map((notice) => (
                    <Box
                      key={`${set}-${notice.id}`}
                      onClick={() => handleClick(notice)}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1, px: 3,
                        cursor: 'pointer',
                        '&:hover .ticker-title': { color: '#e2e8f0' },
                      }}
                    >
                      <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: '#64748b', flexShrink: 0 }} />
                      <Typography
                        className="ticker-title"
                        sx={{
                          fontSize: 12, color: '#94a3b8', fontWeight: 500,
                          whiteSpace: 'nowrap', letterSpacing: '-0.2px',
                          transition: 'color 0.2s',
                        }}
                      >
                        {notice.title}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>

      <NoticeDetailDialog
        open={detailOpen}
        onClose={() => setDetailOpen(false)}
        notice={selectedNotice}
      />
    </>
  );
};

export default NoticeTicker;
